import * as React from "react";
const SvgFiRrStretcher = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-stretcher_svg__a)">
      <path
        fill="#062147"
        d="M21.5 19c-.35 0-.68.072-.982.2l-4.038-3.7 4.909-4.5h1.61a1 1 0 1 0 0-2H9.677a4 4 0 0 1-3.328-1.781L1.832.446A.999.999 0 1 0 .168 1.555l4.516 6.773a5.98 5.98 0 0 0 3.782 2.538l5.055 4.633-4.038 3.7A2.5 2.5 0 1 0 11 21.499c0-.294-.06-.572-.154-.835L15 16.855l4.154 3.808a2.5 2.5 0 0 0-.154.836 2.5 2.5 0 1 0 2.5-2.5zm-9.93-8h6.859l-3.43 3.143z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-stretcher_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrStretcher;
